
<template>
  <div v-wechat-title="title">
    <NativeBar ref="menu" v-model="NativeBarId" />
    <div class="searchRect" :style="'background-color: '+GetColorMainBack()" @click="onSearch">
      <div class="searchLine">
        <i class="iconfont iconsousuo" /> 搜索
      </div>
    </div>
    <div class="adRect">
      <div class="backColor" :style="'background-color: '+GetColorMainBack()" />
      <div v-if="homeAd" class="ad">
        <van-swipe :autoplay="3000">
          <van-swipe-item v-for="(item, index) in homeAd" :key="index">
            <img :src="item.img" @click="jumpUrl(item.url)">
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <div v-if="homeIcon" class="iconRect">
      <div v-for="(item,index) in homeIcon" :key="index" @click="jumpUrl(item.url)"><img :src="item.img"><br>{{ item.title }}</div>
    </div>

    <div v-if="CheckSystemType('DiveBoss') && coachRecommendList && coachRecommendList.length>0" class="coachRect">
      <div v-if="coachRecommendList.length>1" class="changeButton" @click="randomCoachRecommend"><i class="iconfont iconqiehuan" /></div>
      <div class="titleLine rect">教练推荐</div>
      <van-row class="rect">
        <van-col span="1">
          <van-image
            width="6em"
            height="6em"
            fit="cover"
            round
            :src="selectCoachRecommend.coachIcon?selectCoachRecommend.coachIcon:'/img/defaultIcon.jpg'"
          />
        </van-col>
        <van-col span="23">
          <div class="infoRect">
            <div class="title breakAll">{{ selectCoachRecommend.coachName }}</div>
            <div class="about" v-html="selectCoachRecommend.about" />
          </div>
        </van-col>
      </van-row>
      <div class="equips">
        <div class="rect">
          <van-row v-for="item in selectCoachRecommend.list" :key="item.commodityId">
            <van-col span="1">
              <van-image
                width="6em"
                height="6em"
                fit="cover"
                :src="item.icon?item.icon+'?x-oss-process=style/commodityicon':'/img/defaultcom.jpg'"
                @click="onGotoComment(item.commodityId)"
              />
            </van-col>
            <van-col span="23">
              <div class="commodityRect" @click="onGotoComment(item.commodityId)">
                <div class="title breakAll">{{ item.shortName }}</div>
                <div class="about">{{ item.about }}</div>
              </div>
            </van-col>
          </van-row>
        </div>
      </div>
    </div>
    <div class="commodityList">
      <van-row>
        <van-col span="12">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div v-for="(item,index) in list" :key="index" class="rect" @click="onGotoComment(item.commodityId)">
              <template v-if="index%2===0">
                <img :src="item.icon?item.icon+'?x-oss-process=style/commodityicon':'/img/defaultcom.jpg'">
                <div class="title breakAll">
                  {{ item.name }}
                </div>
                <div class="price mainColor">
                  ￥<span>{{ parseInt(item.price) }}</span>.{{ ("0"+parseInt((100*item.price+0.5-100*parseInt(item.price)))).slice(-2) }}
                </div>
              </template>
            </div>
          </van-list>
        </van-col>
        <van-col span="12">
          <div v-for="(item,index) in list" :key="index" class="rect" @click="onGotoComment(item.commodityId)">
            <template v-if="index%2===1">
              <img :src="item.icon?item.icon+'?x-oss-process=style/commodityicon':'/img/defaultcom.jpg'">
              <div class="title breakAll">
                {{ item.name }}
              </div>
              <div class="price mainColor">
                ￥<span>{{ parseInt(item.price) }}</span>.{{ ("0"+parseInt((100*item.price+0.5-100*parseInt(item.price)))).slice(-2) }}
              </div>
            </template>
          </div>
        </van-col>

      </van-row>
    </div>
    <div class="emptyRect" />
    <wxShare v-model="showShare" :title="shareTitle" :desc="shareAbout" :timeline="shareTimeline" :url="shareUrl" :img="shareIcon" @onFinish="onShareFinish" />
  </div>
</template>
<script>
import request from '@/utils/request'
import NativeBar from '@/components/NativeBar'
import { Button, Search, Swipe, SwipeItem, Lazyload, Image, List, Toast, Dialog } from 'vant'
import { checkIsInAlipay, getUserBase, jumpUrl } from '@/utils/base'
import { GetProfitsharingStore, GetProfitsharingAgent, GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import commondata from '@/commondata.js'
import wxShare from '@/components/wxShare'
import { GetSelfUrl, CheckSystemType } from '@/utils/request'
export default {
  name: 'StoreIndex',
  components: {
    [Button.name]: Button,
    [Search.name]: Search,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Lazyload.name]: Lazyload,
    [Image.name]: Image,
    [List.name]: List,
    [Dialog.name]: Dialog,
    NativeBar,
    wxShare
  },
  data() {
    return {
      title: GetSysTitle(),
      NativeBarId: 'home',
      serKey: undefined,
      checked: false,
      price: 123.12,
      coachRecommendList: [],
      selectCoachRecommend: {},
      selectCoachRecommendID: 0,
      homeAd: [],
      homeIcon: [],
      search: {
        typeId: undefined,
        sort: 'BASE',
        tag: undefined,
        key: undefined,
        limit: 30,
        page: 1,
        isRandom: true,
        hashKey: undefined
      },
      loading: undefined,
      finished: false,
      list: [],
      showShare: false,
      shareTitle: '',
      shareAbout: '',
      shareTimeline: '',
      shareUrl: '',
      shareIcon: ''

    }
  },
  activated() {
    this.NativeBarId = ''
    setTimeout(() => {
      this.NativeBarId = 'home'
    }, 1)
    this.$refs.menu.resetNum()
    Toast.clear()
    this.loadBaseData()
    getUserBase(data => {
      console.log('用户数据', data)
      setTimeout(() => {
        if (CheckSystemType('SSI')) {
          if (!GetProfitsharingStore()) {
            Dialog.confirm({
              title: '商城尚未激活',
              message: '潜水中心尚未激活商城,请商城负责人先绑定前后端并激活商城后使用!'
            }).then(() => {
              if (data.proAccountId) {
                this.$router.push('/pro/index')
              }
            })
            return
          }
          if (!GetProfitsharingAgent()) {
            Dialog.confirm({
              title: '商城尚未激活',
              message: '商城代理尚未激活商城,请商城代理负责人先绑定前后端并激活商城后使用!'
            }).then(() => {
              if (data.proAccountId) {
                this.$router.push('/pro/index')
              }
            })
            return
          }
        }
      }, 3000)
    })
  },
  created() {
    this.NativeBarId = ''
    setTimeout(() => {
      this.NativeBarId = 'home'
    }, 0)
    this.search.hashKey = Math.floor(Math.random() * 100000000 + 100)

    this.initCoachRecommendList()
    this.loadBaseData()
  },

  methods: {
    GetProfitsharingStore,
    GetProfitsharingAgent,
    CheckSystemType,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    jumpUrl,
    onShareFinish() {
      this.shareUrl = undefined
    },
    loadBaseData() {
      setTimeout(() => {
        if (!commondata.storeBase) {
          this.loadBaseData()
          return
        }
        console.log('commondata.storeBase', commondata.storeBase)
        this.title = GetSysTitle()
        this.homeIcon = commondata.storeBase.homeIcon
        this.homeAd = commondata.storeBase.homeAd
        this.shareTitle = commondata.storeBase.shareTitle.replace('[store]', commondata.storeBase.title)
        this.shareAbout = commondata.storeBase.shareAbout.replace('[store]', commondata.storeBase.title)
        this.shareTimeline = commondata.storeBase.shareTitle.replace('[store]', commondata.storeBase.title)
        this.shareUrl = undefined
        this.shareUrl = GetSelfUrl() + 'store/index?system=' + commondata.systemBase
        this.shareIcon = commondata.storeBase.shareIcon
      }, 100)
    },
    onSearch() {
      this.$router.push('/store/search')
    },
    randomCoachRecommend() {
      this.selectCoachRecommendID++
      if (this.selectCoachRecommendID >= this.coachRecommendList.length) {
        this.selectCoachRecommendID = 0
      }
      this.selectCoachRecommend = this.coachRecommendList[this.selectCoachRecommendID]
    },
    initCoachRecommendList() {
      request({
        url: '/StoreHelper/getCoachRecommendCommodity',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        this.coachRecommendList = response.data
        this.randomCoachRecommend()
      })
    },
    onGotoComment(id) {
      this.$router.push('/store/item/' + id)
    },

    init() {
      this.list = []
      this.search.page = 1
      this.finished = false
      this.onLoad()
    },
    onLoad() {
      if (this.loading === undefined) {
        this.loading = true
        return
      }
      this.loading = true
      request({
        url: '/Store/getShopCommodityList',
        method: 'post',
        data: this.search
      }).then(response => {
        if (!response.success) {
          this.error = true
          return
        }
        this.loading = false
        this.search.limit = response.data.limit
        this.search.page = response.data.page + 1
        response.data.rows.forEach(item => {
          if (checkIsInAlipay()) {
            if (item.type === 'COMMODITY') {
              this.list.push(item)
            }
          } else {
            this.list.push(item)
          }
        })
        if (response.data.rows.length < this.search.limit) {
          this.finished = true
        }
      })
    }
  }
}
</script>
<style scoped>
.emptyRect{
  height: 4em;
}
.searchRect{
  background-color:#4444ff;
  padding:1em;
}
.searchRect .searchLine{
  background-color: #EEEEEE;
  color: #aeaeae;
  padding: 0.5em 1em;
  border-radius: 2em !important;
}
.adRect {
   position: relative;
}
.adRect .backColor{
  position: absolute;
  height: 50%;
  left: 0;
  right: 0;
}
.adRect .ad{
  padding:0 1em 1em 1em;
  border-radius: 0.5em;
}
.adRect .ad img{
  width: 100%;
  border-radius: 0.5em;
}
.iconRect{
  padding: 0 1.5em;
  display: flex;
  flex-wrap: wrap;
}
.iconRect div{
  width: 20%;
  text-align: center;
  margin-bottom: 1em;
  font-size: 0.7em;
  line-height: 1.4em;
  color:#666;
}
.iconRect img{
  left: 15%;
  width: 70%;
}
.titleLine{
  font-size: 1.1em;
  font-weight: 700;
  line-height: 3em;
}
.coachRect{
  background-color: #fff;
  position: relative;

  margin: 0 1em 1em 1em;
  border-radius: 0.5em;
}
.coachRect .changeButton{
  position: absolute;
  right: 0.9em;
  top:0.9em;
  font-size: 0.9em;
}
.coachRect .rect {
  padding:0 0.8em;
}

.coachRect .infoRect{
  width: calc(100% - 6.5em);
  margin-left: 6.5em;
}
.coachRect .infoRect .title{
  margin-top: 0.3em;
  font-size: 1.1em;
  font-weight: 700;
}
.coachRect .infoRect .about{
  margin-top: 0.5em;
  font-size: 0.8em;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.coachRect .commodityRect{
  width: calc(100% - 6.5em);
  margin-left: 6.5em;
}
.coachRect .commodityRect .title{
  font-weight: 700;
   overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.coachRect .commodityRect .about{
 font-size: 0.9em;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.coachRect .equips{
  border-top: 1px solid #eaeaea;
  margin-top: 1em;
  padding: 1em 0;
}
.commodityList{
  margin: 1em 0.75em;
}
.commodityList .rect{
  margin: 0.5em 0.25em;
  border-radius: 0.5em;
  background-color: #fff;
}
.commodityList .rect .title{
  padding: 0.5em 0.5em;
  font-size: 0.9em;
}
.commodityList .rect .price{
  padding:  0 0.5em 0.5em 0.5em;
  font-weight: 700;
  font-size: 0.9em;
}
.commodityList .rect .price span
{
  font-size: 1.2em;
}
.commodityList img{
  width: 100%;
  border-top-left-radius: 0.5em;
  border-top-right-radius: 0.5em;
}
</style>
